let cid = 0

export default {
  beforeCreate () {
    this._cid = cid.toString()
    cid += 1
  },
}
